import { Quote } from "lucide-react";

interface TestimonialCardProps {
  quote: string;
  company: string;
  context: string;
}

export function TestimonialCard({ quote, company, context }: TestimonialCardProps) {
  return (
    <div className="rounded-xl border border-white/10 bg-white/5 p-6 flex flex-col h-full">
      <Quote className="h-8 w-8 text-brand-violet/50" aria-hidden />
      <p className="mt-4 text-base text-brand-ink/85 leading-relaxed flex-1">
        {quote}
      </p>
      <div className="mt-6 pt-6 border-t border-white/5">
        <p className="text-sm font-semibold text-brand-ink">{company}</p>
        <p className="mt-1 text-xs text-brand-ink/50">{context}</p>
      </div>
    </div>
  );
}
